module.exports = __webpack_public_path__ + "img/github-icon.c55a70d7.svg";